const SearchResultsItemsListStyle = `
`;

export default SearchResultsItemsListStyle;
